/* Model */
class SkuTypeModel extends App.Models.BaseModel {
    modelUrl = 'SkuType';
}
App.Models.SkuType = SkuTypeModel;

/* Collection */
class SkuTypeCollection extends App.Collections.BaseCollection {
    url = 'SkuType';
    model = App.Models.SkuType;
}
App.Collections.SkuTypes = SkuTypeCollection;

/* Router */
class SkuTypeRouter extends App.Routers.BaseRouter {
    constructor() {
        const entityName = 'SkuType';
        const model = App.Models.SkuType;
        const collectionClass = App.Collections.SkuTypes;

        super(entityName, model, collectionClass);
    }
}

App.Routers.SkuType = SkuTypeRouter;